import React from 'react';
import { Button } from '@mui/material';

export const Columns = (deleteUnitItem) => [
  {
    id: 'code',
    numeric: false,
    disablePadding: false,
    label: 'Mã',
    sort: true,
    align: 'center',
  },
  {
    id: 'name',
    numeric: true,
    disablePadding: false,
    label: 'Tên khách hàng',
    align: 'center',
    width: '250px',
  },
  {
    id: 'companyCode',
    numeric: true,
    disablePadding: false,
    label: 'Công ty chủ quản',
    align: 'center',
  },
  {
    id: 'shareCompanyCode',
    numeric: true,
    disablePadding: false,
    label: 'Công ty được chia sẻ',
    align: 'center',
  },
  {
    id: 'actions',
    numeric: false,
    disablePadding: false,
    label: 'Thao tác',
    width: '10px',
    fixed: 'right',
    align: 'center',
    render: (row) => (
      <Button
        variant="contained"
        size="small"
        color="error"
        sx={{ borderRadius: '15px', textTransform: 'none' }}
        onClick={() => window.showConfirm(() => deleteUnitItem(row))}
      >
        Xoá
      </Button>
    ),
  },
];
